module.exports = __webpack_public_path__ + "static/media/nyu.1efef051.svg";